module.exports = __webpack_public_path__ + "static/CurroPitchDeck.446513bd.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Curro/CurroPitchDeck.pdf
// module id = 330
// module chunks = 160870767912026